import { getElementParentRow, addFocusEventListener  } from "../../../utils/formHelpers";

export const handleFocusEvents = (form) => addFocusEventListener(form);

export const handleValueChanges = (form) => ["change", "input"].forEach(event => form.addEventListener(event, (e) => {
    let target = e.target;
    const targetCopy = target;
    const parentRow = getElementParentRow(target);

    if (!parentRow) return;

    if (target.type && target.type === "checkbox") {
        const checkboxId = target.getAttribute("id");

        if (!checkboxId) return;

        target = form.querySelector(`#hidden_${checkboxId}`);

        if(target)
            target.value = targetCopy.checked;
    }

    if (target && target.value && target.value !== "false")
        return parentRow.classList.add("form-row--filled");

    parentRow.classList.remove("form-row--filled");
}));